var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovermanager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56487 25.5534L6.46392 22.271V9.58503L9.57927 6.46968H23.0743L29.544 0H7.01962L0 7.01962V25.038L6.96203 32H29.5382L23.2183 25.5534H9.56487Z",
    fill: "#FFD028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovermanager);
export default __webpack_public_path__ + "static/media/covermanager.f988f8c89a8b8088be6c6f765f7cb983.svg";
export { ForwardRef as ReactComponent };